import { useNavigate } from "react-router";
import { Button } from "@repo/ui";

export const ErrorFallback = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-2xl text-center">
        <h1 className="text-6xl font-black text-red-500">Oops!</h1>
        <div className="mt-8 space-y-4">
          <h2 className="text-3xl font-bold text-gray-900">Something went wrong</h2>
          <p className="mx-auto max-w-md text-lg text-gray-600">
            An unexpected error occurred. Please try refreshing the page or go back to the homepage.
          </p>
        </div>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button
            size="pill"
            variant="primary"
            className="w-30"
            onClick={() => window.location.reload()}
          >
            Refresh
          </Button>
          <Button size="pill" variant="outline" className="w-30" onClick={() => navigate("/")}>
            Go Home
          </Button>
        </div>
      </div>
    </div>
  );
};
